import { Component, ElementRef, OnInit, Renderer2 , ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { Location } from '@angular/common';
@Component({
  selector: 'echexpayment-emailtemplates',
  templateUrl: './createemailtemplate.component.html',
  styleUrls: ['./emailtemplates.component.css']
})
export class EditemailtemplateComponent implements OnInit {
 public emailTemplate: any = {};
 createTemplate: boolean = false;
 editTemplate: boolean = true;
 busy: Subscription;
 private token: string;

public val_template_name :boolean = false;
public val_from_name :boolean = false;
public val_content :boolean = false;
public val_subject :boolean = false;
public val_from_email :boolean = false;
public val_cc_email :boolean = false;
public val_bcc_email :boolean = false;
public val_status :boolean = false;
public invalidfrom_email:boolean = false;
public invalidcc_email:boolean = false;
public invalidbcc_email:boolean = false;
NamecharacterLimitReached: { [key: string]: boolean } = {};

 constructor(private router: Router, private Location : Location, private elementRef : ElementRef, private renderer : Renderer2, private toastr: ToastrService, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService, private route: ActivatedRoute) { 
	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;
  }

  ngOnInit() {
	this.getemailTemplateData();
  }

  eventHandler(){
    this.val_template_name = false;
    this.val_from_name = false;
    this.val_content = false;
    this.val_cc_email = false;
    this.val_bcc_email = false;
    this.val_status = false;
    this.val_subject = false;
    this.val_from_email = false;
    this.invalidfrom_email= false;
    this.invalidcc_email= false;
    this.invalidbcc_email= false;
    }

    goBack(){
      this.Location.back();
    }
  // get email template data by _id
  getemailTemplateData() {
     let params: any = this.route.snapshot.params;
        var data = {
          token:this.token,
          id:params.id
        }
		let responseData = <any>{};
		this.busy = this.echexpaymentService.getemailTemplateData(data).subscribe(
		   response => {
		   responseData = response;
			  this.emailTemplate = responseData.data;
		   },
		   error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
		   }
		);
    }

    focusFirstInvalidControlPlus(): void {
      const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
      if (firstElementWithErrors) {
          firstElementWithErrors.focus();
      }
    }
  
      @ViewChild('submitButton') submitButton: ElementRef;
      moveNext(nextInput: HTMLInputElement, checkbox : number) {
      if(checkbox === 2){
        if (this.submitButton && this.submitButton.nativeElement) {
          this.submitButton.nativeElement.focus();
          this.submitButton.nativeElement.click();
        }
      } else{
        nextInput && nextInput.focus();
      }
    }

	//update email template
    updateEmailTemplate(data) {
        this.focusFirstInvalidControlPlus();   //focus field
        if(data.valid){
        let model: any = data.value;
            let params: any = this.route.snapshot.params;
            model.token = this.token;
            model.id = params.id;
        let responseData = <any>{};
            this.busy = this.echexpaymentService.updateEmailTemplate(model).subscribe(
              response => {
          responseData = response;
                this.toastr.success(responseData.message, 'Success!');
                this.router.navigate(['/email-templates']);
              },
              error => {
            responseData = error;
              this.toastr.error(responseData.error.message, 'Failed!');
          }
            );
      }
    }
    ngAfterViewInit(){
      this.renderer.selectRootElement('#EmailTemplate_Name').focus();
    }

    NameCharacterLimit(event: any, fieldName: string) {
      const maxTextLength = 32; // Maximum text length of 20 characters
      const inputChar = event.key;
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
      const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
    
      if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
        return;
      }
    
      const inputValue = event.target.value;
    
      if (inputValue.length >= maxTextLength) {
        if (allowedKeys.indexOf(inputChar) === -1) {
        this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
        setTimeout(() => {
          this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
        }, 3000);
        event.preventDefault(); // Prevent entering the exceeded character
        }
      }
      }
    
      isNameLimitReached(fieldName: string): boolean {
      return this.NamecharacterLimitReached[fieldName];
      }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/emailtemplates/editemailtemplate.component.ts